import {
	configureStore,
	createListenerMiddleware,
	isRejectedWithValue,
	Middleware,
} from "@reduxjs/toolkit";

import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

import {
	CAMPAIGN_CONFIG_TOO_LARGE_ERROR,
	CAMPAIGN_CONFIG_TOO_LARGE_MESSAGE,
} from "@/utils/campaignConfigGuard";

import { authReducer, authSlice, resetAuth, setAuth } from "@/pages/Public/redux/auth.slice";

import { companiesReducer, companiesSlice } from "@/pages/Private/redux/companies/companies.slice";

import {
	csvEnrichmentReducer,
	csvEnrichmentSlice,
} from "@/pages/Private/redux/csvEnrichment/csvEnrichment.slice";

import { liEventReducer, liEventSlice } from "@/pages/Private/redux/liEvent/liEvent.slice";

import { liPeopleReducer, liPeopleSlice } from "@/pages/Private/redux/liPeople/liPeople.slice";

import { openAiReducer, openAiSlice } from "@/pages/Private/redux/openAi/openAi.slice";

import { listReducer, listSlice } from "@/pages/Private/redux/list/list.slice";

import {
	listOutreachReducer,
	listOutreachSlice,
} from "@/pages/Private/redux/list/list-outreach.slice";

import {
	listOutreachTemplateReducer,
	listOutreachTemplateSlice,
} from "@/pages/Private/redux/list/list-outreach-template.slice";
import {
	listFindPersonReducer,
	listFindPersonSlice,
} from "@/pages/Private/redux/list/list-find-person.slice";

import { searchReducer, searchSlice } from "@/pages/Private/redux/search/search.slice";

import { lemlistSlice } from "@/pages/Private/redux/lemlist/lemlist.slice";

import { customEventSlice } from "@/pages/Private/redux/customEvent/customEvent.slice";

import { scoreSlice } from "@/pages/Private/redux/score/score.slice";

import { scoreOnboardingTestSlice } from "@/pages/Private/redux/score/scoreOnboardingTest.slice";

import {
	jobTitleScreeningReducer,
	jobTitleScreeningSlice,
} from "@/pages/Private/redux/jobTitleScreening/jobTitleScreening.slice";

import { blacklistSlice } from "@/pages/Private/redux/blacklist/blacklist.slice";

import {
	liCompanyActivityReducer,
	liCompanyActivitySlice,
} from "@/pages/Private/redux/liCompanyActivity/liCompanyActivity.slice";

import { jobReducer, jobSlice } from "@/pages/Private/redux/job/job.slice";
import {
	liProfileVisitsReducer,
	liProfileVisitsSlice,
} from "@/pages/Private/redux/liProfileVisits/liProfileVisits.slice";

import { mapSlice } from "@/pages/Private/redux/map/map.slice";

import { requestsSlice } from "@/pages/Private/redux/request/request.slice";

import { liProfileReducer, liProfileSlice } from "@/pages/Private/redux/liProfile/liProfile.slice";

import { cronSlice } from "@/pages/Private/redux/cron/cron.slice";

import {
	userUiFlowReducer,
	userUiFlowSlice,
} from "@/pages/Private/redux/userUiFlow/userUiFlow.slice";

import {
	searchDefaultsReducer,
	searchDefaultsSlice,
} from "@/pages/Private/redux/searchDefaults/searchDefaults.slice";

import { liPostSlice } from "@/pages/Private/redux/liPost/liPost.slice";

import { usageSlice } from "@/pages/Private/redux/usage/usage.slice";

import {
	profileTrackerReducer,
	profileTrackerSlice,
} from "@/pages/Private/redux/profileTracker/profileTracker.slice";

import {
	tableConfigReducer,
	tableConfigSlice,
} from "@/pages/Private/redux/tableConfig/tableConfig.slice";

import { featureReducer, featureSlice } from "@/pages/Private/redux/feature/feature.slice";

import {
	subscriptionReducer,
	subscriptionSlice,
} from "@/pages/Private/redux/subscription/subscription.slice";

import { liSnReducer, liSnSlice } from "@/pages/Private/redux/liSn/liSn.slice";

import {
	websiteScrapeReducer,
	websiteScrapeSlice,
} from "@/pages/Private/redux/websiteScrape/websiteScrape.slice";

import { adminReducer, adminSlice } from "@/pages/Private/redux/admin/admin.slice";

import { emailReducer, emailSlice } from "@/pages/Private/redux/email/email.slice";

import { scheduleSlice, scheduleReducer } from "@/pages/Private/redux/schedule/schedule.slice";

import { fundingMaReducer, fundingMaSlice } from "@/pages/Private/redux/fundingMa/fundingMa.slice";

import { swarmReducer, swarmSlice } from "@/pages/Private/redux/swarm/swarm.slice";

import {
	parallelAiSlice,
	parallelAiSliceReducer,
} from "@/pages/Private/redux/parallelAi/parallelAi.slice";

import {
	notificationReducer,
	notificationSlice,
} from "@/pages/Private/redux/notification/notification.slice";

import { contactReducer, contactSlice } from "@/pages/Private/redux/contact/contact.slice";

import {
	conversationReducer,
	conversationSlice,
} from "@/pages/Private/redux/conversation/conversation.slice";

import {
	organizationReducer,
	organizationSlice,
} from "@/pages/Private/redux/organization/organization.slice";

import {
	featureOnboardingReducer,
	featureOnboardingSlice,
} from "@/pages/Private/redux/featureOnboarding/featureOnboarding.slice";

import {
	onboardingTourReducer,
	onboardingTourSlice,
} from "@/pages/Private/redux/onboardingTour/onboardingTour.slice";

import { zohoReducer, zohoSlice } from "@/pages/Private/redux/zoho/zoho.slice";

import { pipedriveReducer, pipedriveSlice } from "@/pages/Private/redux/pipedrive/pipedrive.slice";

import { dynamicsReducer, dynamicsSlice } from "@/pages/Private/redux/dynamics/dynamics.slice";
import {
	salesforceReducer,
	salesforceSlice,
} from "@/pages/Private/redux/salesforce/salesforce.slice";

import { hubspotReducer, hubspotSlice } from "@/pages/Private/redux/hubspot/hubspot.slice";

import {
	companyEnrichReducer,
	companyEnrichSlice,
} from "@/pages/Private/redux/companyEnrich/companyEnrich.slice";

import {
	listPreviewReducer,
	listPreviewSlice,
} from "@/pages/Private/redux/listPreview/listPreview.slice";

import {
	supportDashboardReducer,
	supportDashboardSlice,
} from "@/pages/Private/redux/support-dashboard/support-dashboard.slice";

import {
	privacyPolicyReducer,
	privacyPolicySlice,
} from "@/pages/Public/redux/privacyPolicy/privacyPolicy.slice";

import {
	copywritingSettingsReducer,
	copywritingSettingsSlice,
} from "@/pages/Private/redux/copywritingSettings/copywritingSettings.slice";

import {
	copywritingFrameworkReducer,
	copywritingFrameworkSlice,
} from "@/pages/Private/redux/copywritingFramework/copywritingFramework.slice";

import {
	languageRuleReducer,
	languageRuleSlice,
} from "@/pages/Private/redux/languageRule/languageRule.slice";

import {
	campaignRoutingReducer,
	campaignRoutingSlice,
} from "@/pages/Private/redux/campaignRouting/campaignRouting.slice";

import {
	copywritingOrchestrationReducer,
	copywritingOrchestrationSlice,
} from "@/pages/Private/redux/copywritingOrchestration/copywritingOrchestration.slice";

import {
	reviewSessionReducer,
	reviewSessionSlice,
} from "@/pages/Private/redux/reviewSession/reviewSession.slice";

import { dashboardReducer, dashboardSlice } from "@/pages/Private/redux/dashboard/dashboard.slice";

import { feedReducer, feedSlice } from "@/pages/Private/redux/feed/feed.slice";

import {
	deepResearchReducer,
	deepResearchSlice,
} from "@/pages/Private/redux/deepResearch/deepResearch.slice";

import {
	helpCenterReducer,
	helpCenterSlice,
} from "@/pages/Private/redux/helpCenter/helpCenter.slice";

import { rtkRejectQueryMiddleware } from "./rejectRedirect";

import { ROUTE_CONFIG } from "../routes/config";
import { allTags, api } from "./api";

const { LOGOUT, ERROR_PAGE } = ROUTE_CONFIG;

// Listener middleware to invalidate tags when auth changes
const authListenerMiddleware = createListenerMiddleware();

authListenerMiddleware.startListening({
	actionCreator: resetAuth,
	effect: (action, listenerApi) => {
		listenerApi.dispatch(api.util.invalidateTags(allTags));
	},
});

authListenerMiddleware.startListening({
	actionCreator: setAuth,
	effect: (action, listenerApi) => {
		listenerApi.dispatch(api.util.invalidateTags(allTags));
	},
});

// Exported so tests can build an isolated store with the production reducer
// map (see src/test/render.tsx).
export const rootReducer = {
	[authSlice.name]: authReducer,
	[api.reducerPath]: api.reducer,
	[jobSlice.name]: jobReducer,
	[parallelAiSlice.name]: parallelAiSliceReducer,
	[companiesSlice.name]: companiesReducer,
	[csvEnrichmentSlice.name]: csvEnrichmentReducer,
	[liEventSlice.name]: liEventReducer,
	[liPeopleSlice.name]: liPeopleReducer,
	[liCompanyActivitySlice.name]: liCompanyActivityReducer,
	[liProfileVisitsSlice.name]: liProfileVisitsReducer,
	[liProfileSlice.name]: liProfileReducer,
	[openAiSlice.name]: openAiReducer,
	[listSlice.name]: listReducer,
	[listOutreachSlice.name]: listOutreachReducer,
	[listOutreachTemplateSlice.name]: listOutreachTemplateReducer,
	[listFindPersonSlice.name]: listFindPersonReducer,
	[searchSlice.name]: searchReducer,
	[lemlistSlice.name]: lemlistSlice.reducer,
	[customEventSlice.name]: customEventSlice.reducer,
	[scoreSlice.name]: scoreSlice.reducer,
	[scoreOnboardingTestSlice.name]: scoreOnboardingTestSlice.reducer,
	[jobTitleScreeningSlice.name]: jobTitleScreeningReducer,
	[blacklistSlice.name]: blacklistSlice.reducer,
	[mapSlice.name]: mapSlice.reducer,
	[requestsSlice.name]: requestsSlice.reducer,
	[cronSlice.name]: cronSlice.reducer,
	[liPostSlice.name]: liPostSlice.reducer,
	[usageSlice.name]: usageSlice.reducer,
	[profileTrackerSlice.name]: profileTrackerReducer,
	[tableConfigSlice.name]: tableConfigReducer,
	[featureSlice.name]: featureReducer,
	[subscriptionSlice.name]: subscriptionReducer,
	[liSnSlice.name]: liSnReducer,
	[websiteScrapeSlice.name]: websiteScrapeReducer,
	[adminSlice.name]: adminReducer,
	[emailSlice.name]: emailReducer,
	[scheduleSlice.name]: scheduleReducer,
	[fundingMaSlice.name]: fundingMaReducer,
	[swarmSlice.name]: swarmReducer,
	[notificationSlice.name]: notificationReducer,
	[contactSlice.name]: contactReducer,
	[conversationSlice.name]: conversationReducer,
	[organizationSlice.name]: organizationReducer,
	[featureOnboardingSlice.name]: featureOnboardingReducer,
	[onboardingTourSlice.name]: onboardingTourReducer,
	[zohoSlice.name]: zohoReducer,
	[pipedriveSlice.name]: pipedriveReducer,
	[dynamicsSlice.name]: dynamicsReducer,
	[salesforceSlice.name]: salesforceReducer,
	[hubspotSlice.name]: hubspotReducer,
	[companyEnrichSlice.name]: companyEnrichReducer,
	[listPreviewSlice.name]: listPreviewReducer,
	[supportDashboardSlice.name]: supportDashboardReducer,
	[privacyPolicySlice.name]: privacyPolicyReducer,
	[copywritingSettingsSlice.name]: copywritingSettingsReducer,
	[copywritingFrameworkSlice.name]: copywritingFrameworkReducer,
	[copywritingOrchestrationSlice.name]: copywritingOrchestrationReducer,
	[languageRuleSlice.name]: languageRuleReducer,
	[campaignRoutingSlice.name]: campaignRoutingReducer,
	[reviewSessionSlice.name]: reviewSessionReducer,
	[dashboardSlice.name]: dashboardReducer,
	[userUiFlowSlice.name]: userUiFlowReducer,
	[searchDefaultsSlice.name]: searchDefaultsReducer,
	[feedSlice.name]: feedReducer,
	[helpCenterSlice.name]: helpCenterReducer,
	[deepResearchSlice.name]: deepResearchReducer,
};

export const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({ serializableCheck: false })
			.concat(rtkRejectQueryMiddleware)
			.concat(authListenerMiddleware.middleware)
			.concat(api.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
